import { render, staticRenderFns } from "./MessageCreateModal.vue?vue&type=template&id=8e8c130e&"
import script from "./MessageCreateModal.vue?vue&type=script&lang=js&"
export * from "./MessageCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports